/**
 * Module pour gérer les fonctionnalités des détails de domaine
 */

class DomainDetailsHelper {
  constructor() {
    this.textModal = document.getElementById('textModal');
    this.init();
  }

  init() {
    this.setupTruncatedTextModals();
    this.setupCardNavigation();
  }

  setupTruncatedTextModals() {
    // Écouteur d'événement pour les éléments tronqués qui ouvrent la modale
    document.querySelectorAll('[data-bs-toggle="modal"][data-full-text]').forEach(element => {
      element.addEventListener('click', (event) => {
        this.handleModalOpen(event);
      });
    });

    // Écouteur pour l'ouverture de la modale
    if (this.textModal) {
      this.textModal.addEventListener('show.bs.modal', (event) => {
        const button = event.relatedTarget;
        this.populateModal(button);
      });
    }
  }

  handleModalOpen(event) {
    this.populateModal(event.currentTarget);
  }

  populateModal(element) {
    if (!element || !this.textModal) return;

    const fullText = element.getAttribute('data-full-text');
    const contentType = element.getAttribute('data-content-type') || 'Détail';

    // Définir le titre et le contenu
    const titleElement = this.textModal.querySelector('.modal-title');
    const contentElement = this.textModal.querySelector('#fullTextContent');

    if (titleElement) titleElement.textContent = contentType;
    if (contentElement) {
      contentElement.textContent = fullText;
      this.adjustModalSize(fullText);
      this.addHelperContent(contentType, fullText);
    }
  }

  adjustModalSize(content) {
    // Ajuster la taille de la modale en fonction de la longueur du contenu
    const modalDialog = this.textModal?.querySelector('.modal-dialog');
    if (!modalDialog) return;

    if (content && content.length > 100) {
      // Pour les contenus longs, limiter la hauteur et ajouter un défilement
      const modalBody = this.textModal.querySelector('.modal-body');
      if (modalBody) {
        modalBody.style.maxHeight = '200px'; // Hauteur maximale pour les longs textes
        modalBody.style.overflowY = 'auto';
      }
    } else {
      // Pour les contenus courts, pas de limite de hauteur
      const modalBody = this.textModal.querySelector('.modal-body');
      if (modalBody) {
        modalBody.style.maxHeight = '';
        modalBody.style.overflowY = '';
      }
    }
  }

  addHelperContent(contentType, mainContent) {
    // Supprimer tout contenu d'aide précédent
    const existingHelper = this.textModal.querySelector('.helper-content');
    if (existingHelper) existingHelper.remove();

    // Ajouter du contenu informatif supplémentaire pour certains types de données
    let helperContent = '';

    // Définir le contenu d'aide selon le type
    switch(contentType) {
      case 'Trafic mobile (semaine)':
        helperContent = 'Pourcentage de visiteurs utilisant un appareil mobile pendant la semaine. Une valeur élevée indique que vos utilisateurs consultent principalement votre site sur mobile en semaine.';
        break;
      case 'Trafic mobile (weekend)':
        helperContent = 'Pourcentage de visiteurs utilisant un appareil mobile pendant le weekend. Une comparaison avec le trafic de semaine peut révéler des habitudes de navigation différentes.';
        break;
      case 'Taux de rebond':
        helperContent = 'Pourcentage de visiteurs qui quittent votre site après avoir consulté une seule page. Un taux élevé peut indiquer des problèmes d\'expérience utilisateur ou de pertinence du contenu.';
        break;
      case 'Type de visiteurs':
        helperContent = 'Catégorisation principale de vos visiteurs basée sur leur comportement et leurs caractéristiques.';
        break;
      case 'Clics par session':
      case 'Temps minimum':
        helperContent = 'Ces métriques d\'engagement vous aident à comprendre comment les visiteurs interagissent avec votre site.';
        break;
      case 'Localisation':
        helperContent = 'Zone géographique où votre site est optimisé. La distance indique le rayon approximatif autour du point central.';
        break;
    }

    // Ajouter le contenu d'aide à la modale s'il existe
    if (helperContent) {
      const modalBody = this.textModal.querySelector('.modal-body');
      if (modalBody) {
        // Créer un séparateur et un paragraphe pour l'aide
        const separator = document.createElement('hr');
        separator.className = 'my-2';

        const helperParagraph = document.createElement('p');
        helperParagraph.className = 'text-muted small mt-2 mb-0 helper-content';
        helperParagraph.textContent = helperContent;

        // Ajouter après le contenu principal
        modalBody.appendChild(separator);
        modalBody.appendChild(helperParagraph);
      }
    }
  }

  setupCardNavigation() {
    document.querySelectorAll('.card.cursor-pointer').forEach(card => {
      // Éviter les doublons d'écouteurs d'événements
      if (card.getAttribute('data-click-bound') === 'true') return;

      card.addEventListener('click', function(e) {
        // Ne pas naviguer si on clique sur un élément de formulaire ou modal
        if (e.target.closest('input, button, select, textarea, a, .form-check, [data-bs-toggle="modal"]')) {
          return;
        }

        const href = this.getAttribute('data-href');
        if (href) {
          window.location.href = href;
        }
      });

      // Marquer comme ayant déjà un écouteur d'événement
      card.setAttribute('data-click-bound', 'true');

      // Ajouter un effet de survol pour indiquer que la carte est cliquable
      card.classList.add('hover-effect');
    });
  }
}

// Initialisation au chargement de la page
document.addEventListener('DOMContentLoaded', () => {
  window.domainDetailsHelper = new DomainDetailsHelper();
});

// Initialisation lors des navigations Turbolinks
document.addEventListener('turbolinks:load', () => {
  window.domainDetailsHelper = new DomainDetailsHelper();
});

export default DomainDetailsHelper;
